"use client"; // Indicate this is a client component

import React, { useEffect, useState } from "react";
import { useParams } from "wouter"; // Continue using wouter's useParams
import { Modal } from "@/components/_shared/Modal";
import PageLayout from "@/components/_shared/PageLayout";
import TOTPForm from "@/components/totp-generator/TOTPForm";

// Define the specific instructions for this page (same as /totp)

export default function TOTPCodePage() {
	useEffect(() => {
		document.title = "TOTP Generator";
	}, []);
	const params = useParams<{ code?: string }>(); // Specify type for params
	const initialCode = params?.code || ""; // Get code from wouter params

	return (
		<PageLayout
			additionalItemsToDelete={["totp_pinned"]}
			confirmationText="Willst du wirklich alle TOTP-Daten löschen? Dies wird alle Einstellungen und angehefteten Codes zurücksetzen und kann nicht rückgängig gemacht werden."
			title="TOTP Generator"
			toolId="totp"
		>
			<main className="grid grid-cols-1 gap-6">
				{/* Pass the initial code from the URL */}
				<TOTPForm initialCode={initialCode} />
			</main>
		</PageLayout>
	);
}
